import React from 'react';
import PropTypes from 'prop-types';

import FinanceMethodPage from 'payment-calculator/components/PaymentCalculatorDetails/components/FinanceMethodPage/FinanceMethodPage.jsx';
import CashMethodPage from 'payment-calculator/components/PaymentCalculatorDetails/components/CashMethodPage/CashMethodPage.jsx';

const PurchaseMethodsTabControlContainer = ({ cashPurchaseSelected }) => {
    return (
        <div className="showroom-calculator-new-inner">
            {cashPurchaseSelected ? <CashMethodPage /> : <FinanceMethodPage />}
        </div>
    );
};

PurchaseMethodsTabControlContainer.propTypes = {
    cashPurchaseSelected: PropTypes.bool.isRequired,
};

PurchaseMethodsTabControlContainer.displayName = 'PurchaseMethodsTabControlContainer';

export default PurchaseMethodsTabControlContainer;



// WEBPACK FOOTER //
// ./src/components/PaymentCalculatorDetails/components/PurchaseMethodsTabControl/PurchaseMethodsTabControlContainer.jsx